module.exports = __webpack_public_path__ + "img/AE5002-01.f92c4feb.jpg";